import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';

class JacksonDetailedAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { account, } = this.props;
    const realProperties = ObjectUtils.formatStringAsJSONArray(account.realProperties);
    const vehicleProperties = ObjectUtils.formatStringAsJSONArray(account.vehicleProperties);
    const items = VerticalLabelList.toList({
      Id: account.id,
      'External Account Id': account.externalAccountId,
      'Owner First Name': account.ownerFirstName,
      'Owner Last Name': account.ownerLastName,
      'Propert Type': account.propertyType,
      'Assess Value': account.assessedValue_value,
      'Market Value': account.marketValue_value,
      'Taxable Value': account.taxableValue_value,
      'Effective from Date': moment(account.effectiveFromDate)
        .utc()
        .format(),
      'Street Number': account.streetNumber,
      'Street Name': account.streetName,
      City: account.city,
      Zip: account.zip,
      'Non-Licensed Properties': account.nonLicensedProperties,
    });
    const vehicleGridModel = Grid.toModelFromList(vehicleProperties);
    const realPropertiesModel = Grid.toModelFromList(realProperties);

    return (
      <div className="container">
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Account Summary" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={items} />
          </FieldSet>
          <div style={{ marginTop: '20px', }}>
            <FieldSet title="Vehicle Properties" style={{ maxHeight: '200px', }}>
              <Grid
                headers={vehicleGridModel.headers}
                rows={vehicleGridModel.format(vehicleProperties)}
              />
            </FieldSet>
          </div>
          <div style={{ marginTop: '20px', }}>
            <FieldSet title="Real Properties" style={{ maxHeight: '200px', }}>
              <Grid
                headers={realPropertiesModel.headers}
                rows={realPropertiesModel.format(realProperties)}
              />
            </FieldSet>
          </div>
        </div>
      </div>
    );
  }
}

JacksonDetailedAccount.propTypes = {
  account: PropTypes.instanceOf(Object).isRequired,
};

export default JacksonDetailedAccount;
